import { HeaderText } from "@src/components/general/HeaderText";
import { Logo } from "@src/components/general/Logo";
import { Text } from "@src/components/general/Text";
import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/components/layout/Flexbox";
import { Button } from "@src/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const HomePage = () => {
  return (
    <VerticalFlexbox
      alignItems="center"
      justifyContent="center"
      className="min-h-screen w-full bg-gradient-to-b from-background to-muted/50 px-6 py-12"
    >
      <VerticalFlexbox
        alignItems="center"
        gap="md"
        className="max-w-xl text-center"
      >
        <HorizontalFlexbox alignItems="center" gap="sm">
          <Logo className="size-10" />
          <Text as="span" sizing="xl" fontWeight={600}>
            Stitch.AI
          </Text>
        </HorizontalFlexbox>
        <HeaderText tag="h1" className="text-4xl leading-tight sm:text-5xl">
          The clinical copilot where every thread meets.
        </HeaderText>
        <Text appearance="subdued" className="max-w-md">
          Prep, document, code, and close — Stitch helps your team deliver
          value-based care without the busywork.
        </Text>
        <Button
          asChild
          size="lg"
          className="bg-accent text-accent-foreground hover:bg-accent/90"
        >
          <Link to="/dashboard">
            Open dashboard
            <ArrowRight className="ml-1 size-4" />
          </Link>
        </Button>
      </VerticalFlexbox>
    </VerticalFlexbox>
  );
};
